var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Modal from "@cloudscape-design/components/modal";
import { IToolbarButtonActiveContentType, } from "../../types";
import { ToolbarButtonMenu } from "./toolbar-button-menu";
import { ToolbarButtonDropdownMenuItems } from "./toolbar-button-dropdown-menu-items";
/**
 * Internal component used to render active content for stateful toolbar buttons.
 * This component is used by the ToolbarButtonStateful component.
 * It renders the active content based on the activeStateContentType prop.
 */
export var ToolbarButtonActiveStateContent = function (props) {
    var isExpanded = props.isExpanded, setIsExpanded = props.setIsExpanded, label = props.label, activeStateContentType = props.activeStateContentType, buttonContentReferenceElement = props.buttonContentReferenceElement, onKeyDown = props.onKeyDown;
    var close = function () { return setIsExpanded(false); };
    if (!isExpanded) {
        return null;
    }
    if (activeStateContentType === IToolbarButtonActiveContentType.MODAL) {
        var ActiveStateContent = props.ActiveStateContent, ariaLabelCloseModal = props.ariaLabelCloseModal, modalRoot = props.modalRoot;
        return (_jsx(Modal, __assign({ header: label, visible: isExpanded, onDismiss: function () {
                setIsExpanded(function (s) { return !s; });
            }, size: "large", closeAriaLabel: ariaLabelCloseModal, modalRoot: modalRoot }, { children: _jsx(ActiveStateContent, { close: close }) })));
    }
    if (activeStateContentType === IToolbarButtonActiveContentType.HORIZONTAL_MENU) {
        var ActiveStateContent = props.ActiveStateContent, menuReferenceElement = props.menuReferenceElement, setMenuReferenceElement = props.setMenuReferenceElement;
        return (_jsx(ToolbarButtonMenu, __assign({ anchorEl: buttonContentReferenceElement, open: isExpanded, activeStateContentType: activeStateContentType, menuReferenceElement: menuReferenceElement, setMenuReferenceElement: setMenuReferenceElement }, { children: _jsx(ActiveStateContent, { close: close }) })));
    }
    if (activeStateContentType === IToolbarButtonActiveContentType.DROPDOWN) {
        var items = props.items, menuReferenceElement = props.menuReferenceElement, setMenuReferenceElement = props.setMenuReferenceElement;
        return (_jsx(ToolbarButtonMenu, __assign({ anchorEl: buttonContentReferenceElement, open: isExpanded, activeStateContentType: activeStateContentType, menuReferenceElement: menuReferenceElement, setMenuReferenceElement: setMenuReferenceElement }, { children: _jsx(ToolbarButtonDropdownMenuItems, { items: items, close: close, onKeyDown: onKeyDown }) })));
    }
    return null;
};
